// extracted by mini-css-extract-plugin
export default {"field":"DueDateField_field__kJx5Q","icon":"DueDateField_icon__aF-GL","text":"DueDateField_text__LNExd"};